import McBasicTable from './McBasicTable';

export default McBasicTable;
